import { render, staticRenderFns } from "./ssiv-login.vue?vue&type=template&id=53bbffe9&scoped=true"
import script from "./ssiv-login.vue?vue&type=script&lang=js"
export * from "./ssiv-login.vue?vue&type=script&lang=js"
import style0 from "./ssiv-login.vue?vue&type=style&index=0&id=53bbffe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bbffe9",
  null
  
)

export default component.exports